<template>
  <div class="main">
    <Loading v-if="loading" />
    <div v-else-if="!delivering" class="container">
      <h1>
        You Are Not Saving Anyone's Savour At The Moment, Start By
        <router-link :to="{ name: 'Saviour' }">Becoming a Saviour</router-link>
        Today!
      </h1>
      <img src="../assets/memeImages/YoureFree.jpeg" alt="" />
    </div>
    <div v-else class="container">
      <div class="header">
        <h2>Continue Saving The Savour</h2>
        <p>
          Location To Be Delivered To:
        </p>
        <b>{{ orderDetails.userLocation }}</b>
        <p>
          Restaurant:
        </p>
        <b>{{ orderDetails.restaurantName }}</b>
        <p>
          Location Of The Restaurant:
        </p>
        <b>{{ orderDetails.restaurantLocation }}</b>
      </div>
      <div class="order-details">
        <h2>Order Details</h2>
        <OrderSummaryItemView
          v-for="(food, index) in orderDetails.foodItems"
          :key="food"
          :itemName="food"
          :itemQuantity="orderDetails.foodItemsQuantity[index]"
        />
        <h6>Additional Requests:</h6>
        <p>{{ orderDetails.additionalRequests }}</p>
      </div>
      <!--
      <h2>OrderDetails:</h2>
      <table border="1px">
        <thead>
          <tr>
            <th class="tg-0lax">No.</th>
            <th>Food</th>
            <th>Quantity</th>
            <th class="tg-0lax">Remark</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(food, index) in orderDetails.foodItems" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ food }}</td>
            <td>{{ orderDetails.foodItemsQuantity[index] }}</td>
            <td>{{ orderDetails.foodItemsRemarks[index] }}</td>
          </tr>
        </tbody>
      </table>
      -->
      <div class="timer-and-button">
        <Timer :deadline="deadline" />
        <button
          class="order-placed-at-restaurant-button"
          @click="orderPlacedAtRestaurant"
          v-if="orderPlacedButton"
        >
          Order Placed At The Restaurant/Stall
        </button>
        <button
          class="order-picked-up-button"
          @click="OrderPickedUpFromRestaurant"
          v-if="orderPickedButton"
        >
          Order Picked Up
        </button>
        <button
          class="en-route-to-save-savour-button"
          @click="enRouteToSaveSavour"
          v-if="enRouteToSaveButton"
        >
          En Route To Save Savour!
        </button>
        <button
          class="delivered-button"
          @click="deliveredTheOrder"
          v-if="deliveredButton"
        >
          I Have Delivered The Order!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading.vue";
import Timer from "../components/Timer.vue";
import db from "../firebase/firebaseInit";
import firebase from "firebase/app";
import OrderSummaryItemView from "../components/OrderSummaryItemView";

export default {
  name: "Tasks",
  data() {
    return {
      orderDetails: null,
      deadline: null,
      loading: true,
      delivering: null,
      deliveringId: null,
      orderId: null,
      orderPlacedButton: true,
      orderPickedButton: false,
      enRouteToSaveButton: false,
      deliveredButton: false,
    };
  },
  components: {
    Timer,
    Loading,
    OrderSummaryItemView,
  },
  async mounted() {
    //To catch profile Id and then see if this user is delivering or not
    var userRef = await db
      .collection("users")
      .doc(firebase.auth().currentUser.uid);
    await userRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("The userId has been fetched:", doc.data());
          console.log(
            "The user delivering has been fetched:",
            doc.data().delivering
          );
          console.log(
            "The deliveringId has been fetched:",
            doc.data().deliveringId
          );
          this.delivering = doc.data().delivering;
          this.deliveringId = doc.data().deliveringId;
          this.orderId = this.deliveringId;

          this.getOrderDetails(doc.data().deliveringId);
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document! 1");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  },
  methods: {
    async getOrderDetails(id) {
      try {
        var docRef = await db.collection("orders").doc(id);
        await docRef
          .get()
          .then((doc) => {
            if (doc.exists) {
              this.orderDetails = doc.data();
              this.deadline = this.orderDetails.deliveryTime.toDate();

              if (!this.orderDetails.orderPlacedAtRestaurant) {
                this.orderPlacedButton = true;
              } else {
                this.orderPlacedButton = false;
              }

              if (this.orderDetails.orderPlacedAtRestaurant) {
                this.orderPlacedButton = false;
                this.orderPickedButton = true;
              }

              if (this.orderDetails.orderPickedFromRestaurant) {
                this.orderPickedButton = false;
                this.enRouteToSaveButton = true;
              }

              if (this.orderDetails.enRouteToSave) {
                this.enRouteToSaveButton = false;
                this.deliveredButton = true;
              }
              this.loading = false;
            } else {
              // doc.data() will be undefined in this case
              console.log("No such document! 2");
              this.loading = false;
            }
          })
          .catch((error) => {
            console.log("Error getting document:", error);
          });
      } catch (error) {
        this.loading = false;
      }
    },
    async orderPlacedAtRestaurant() {
      this.orderPlacedButton = false;
      this.orderPickedButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          orderPlacedAtRestaurant: true,
        });
    },
    async OrderPickedUpFromRestaurant() {
      this.orderPickedButton = false;
      this.enRouteToSaveButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          orderPickedFromRestaurant: true,
        });
    },
    async enRouteToSaveSavour() {
      this.enRouteToSaveButton = false;
      this.deliveredButton = true;
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          enRouteToSave: true,
        });
    },
    async deliveredTheOrder() {
      await db
        .collection("users")
        .doc(this.$store.state.profileId)
        .update({
          delivering: false,
          deliveringId: "",
          ordersDelivered: firebase.firestore.FieldValue.arrayUnion(
            this.orderId
          ),
        });
      await db
        .collection("orders")
        .doc(this.orderId)
        .update({
          delivered: true,
        });
      this.$router.push({
        name: "DeliveredTheOrder",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;

  .container {
    margin: 10px 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    gap: 16px;

    img {
      margin: 0 auto;
      height: 60%;
      width: 300px;
      border-radius: 8px;
    }

    @media (min-width: 800px) {
      flex-direction: row;

      img {
        height: auto;
        width: auto;
        border-radius: 8px;
      }
    }

    .header {
      flex-basis: 34%;

      padding: 20px;
      background-color: #f1f1f1;
      border-radius: 8px;

      h3 {
        margin-bottom: 20px;
      }

      p,
      b {
        font-size: 20px;
      }

      p {
        margin-top: 10px;
      }
    }
  }

  .order-details {
    flex-basis: 33%;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;

    h2 {
      color: #fff;
      text-align: center;
    }

    p {
      text-align: left;
      color: #fff;
      font-size: 16px;
    }

    h6 {
      margin-top: 5px;
      margin-bottom: 0;
      color: #fff;
      font-size: 20px;
      text-align: left;
    }
  }

  .timer-and-button {
    flex-basis: 33%;
    display: flex;
    flex-direction: column;

    button {
      margin: 10px auto;
      min-width: 180px;

      &:hover {
        cursor: pointer;
        background-color: rgb(50, 50, 50);
        transition: 0.25s;
      }
    }

    .delivered-button {
      margin: 10px auto;
      min-width: 180px;

      &:hover {
        cursor: pointer;
        background-color: rgb(50, 50, 50);
        transition: 0.25s;
      }
    }
  }
}
</style>
